module.exports = {
      id: "cancel-usage",
      viewBox: "0 0 241.171 241.171",
      url: "/" + "sprite-6d93c42890617d6f6477c703e3b36dd9.svg#cancel",
      toString: function () {
        return this.url;
      }
    }